export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10232.de56f2d5.jpg";